import axios from "axios";
import { queryParamName, helpers, sortOrder, typeConst } from "../services/utilities";

/**
 * Create query string from parameters
 * @param {String} keyword 
 * @param {Array} categories 
 * @param {Array} countries 
 * @param {Array} languages 
 * @param {Array} crops 
 * @param {String} type 
 * @param {String} order 
 * @param {Number} page 
 * @param {Boolean} includeFilter 
 * @param {*} settings 
 * @returns 
 */
const createQueryString = (
    keyword,
    categories,
    countries,
    languages,
    crops,
    type,
    order,
    page,
    pageSize,
    includeFilter,
    settings
) => {
    const params = new URLSearchParams();

    if (helpers.notEmptyNull(keyword))
        params.append(queryParamName.keyword, keyword);

    if (Array.isArray(categories) && categories.length > 0)
        categories.forEach((s) => {
            params.append(queryParamName.categories, s);
        });

    if (Array.isArray(countries) && countries.length > 0)
        countries.forEach((s) => {
            params.append(queryParamName.countries, s);
        });

    if (Array.isArray(languages) && languages.length > 0)
        languages.forEach((s) => {
            params.append(queryParamName.languages, s);
        });

    if (Array.isArray(crops) && crops.length > 0)
        crops.forEach((s) => {
            params.append(queryParamName.crops, s);
        });

    if (helpers.notEmptyNull(type)) params.append(queryParamName.type, type);

    if (helpers.notEmptyNull(order)) params.append(queryParamName.order, order);
    else params.append(queryParamName.order, sortOrder.acending);

    if (helpers.notEmptyNull(page) && !isNaN(page))
        params.append(queryParamName.page, page);
    else params.append(queryParamName.order, 1);

    if (helpers.notEmptyNull(pageSize)) params.append(queryParamName.pageSize, pageSize);
    else params.append(queryParamName.pageSize, settings.pageSize);

    params.append(queryParamName.includefilter, includeFilter);

    return params.toString();
};

/**
 * Get data from management service
 */
export const dataServices = {
    search: async (
        keyword,
        categories,
        countries,
        languages,
        crops,
        type,
        order,
        page,
        pageSize,
        includeFilter,
        settings
    ) => {

        const apiUrl = `${settings.api_url}/${settings.search_endpoint
            }?${createQueryString(
                keyword,
                categories,
                countries,
                languages,
                crops,
                type,
                order,
                page,
                pageSize,
                includeFilter,
                settings
            )}`;

        return await axios.get(apiUrl);
    },
    analyticpush: async (keyword,
        categories,
        countries,
        languages,
        crops,
        type,
        settings) => {
        //Push analytic data when there is session is and analytic enpoint defined
        if (settings.sessionId && settings.analytic_endpoint) {
            var data = {
                session: settings.sessionId,
                keyword: keyword ?? '',
                categories: categories.map(s => s.value) ?? [],
                countries: countries.map(s => s.value) ?? [],
                languages: languages.map(s => s.value) ?? [],
                crops: crops.map(s => s.value) ?? [],
                type: type === null || type === undefined || type === '' ? typeConst.allDevices : type
            };

            const params = new URLSearchParams();
            params.append('data', encodeURIComponent(JSON.stringify(data)))

            return await axios.get(`${settings.analytic_endpoint}?${params.toString()}`);
        }
    }
};
